<div class="wrapper">

    <div class="content-wrapper">
        <div class="br-section-wrapper" style="margin-top: 20px">
            <div class="row menu-container align-items-start" style="padding: 15px; background: #f8f9fa; border-radius: 8px; margin: 0 15px; box-shadow: 0 2px 4px rgba(0,0,0,0.1);">

                <div class="col-2 menu-section-compact">
                    <div class="filter-header-compact">Schedule</div>
                    <div class="input-wrapper">
                        <div class="form-group hidden">
                            <div class="input-group">
                                <input name="datepicker" class="form-control" style="display: none;" ngbDatepicker
                                    #datepicker="ngbDatepicker" [autoClose]="true"
                                    (dateSelect)="onDateSelection($event)" [displayMonths]="1" outsideDays="hidden">
                            </div>
                        </div>
                        <div class="form-group" style="margin-bottom: 8px;">
                            <div class="input-group">
                                <input #dpFromDate class="form-control compact-input" placeholder="yyyy-mm-dd"
                                    name="dpFromDate" [value]="formatDateForDisplay(fromDate)"
                                    (input)="fromDate = validateInput(fromDate, dpFromDate.value)">
                                <div class="input-group-append">
                                    <button class="btn btn-outline-secondary calendar-btn"
                                        (click)="datepicker.toggle()" type="button">
                                        <i class="fa fa-calendar" aria-hidden="true"></i>
                                    </button>
                                </div>
                            </div>
                        </div>
                        <div class="checkbox-wrapper">
                            <label class="checkbox-label">
                                <input type="checkbox" [(ngModel)]="hideCompletedLoads" (change)="filterCompletedBols()">
                                Hide Completed Loads
                            </label>
                        </div>
                    </div>
                </div>

                <div class="col-2 menu-section-compact">
                    <div class="filter-header-compact">Reports</div>
                    <div class="input-wrapper">
                        <select class="form-select-compact" [(ngModel)]="selectedReportType" (ngModelChange)="printDiv()">
                            <option [ngValue]="null">Select Type</option>
                            <option [ngValue]="'By Driver'">By Driver</option>
                        </select>
                        <button class="print-button-compact" (click)="printDiv()">Print</button>
                    </div>
                </div>
                <div class="col-3 menu-section-compact">
                    <div class="filter-header-compact">Search</div>
                    <div class="input-wrapper">
                        <select class="form-select-compact" [(ngModel)]="selectedFilter" (ngModelChange)="resetFilters()">
                            <option [ngValue]="'loadingBol'">By Loading bol</option>
                            <option [ngValue]="'invoiceNumber'">By Invoice Number</option>
                            <option [ngValue]="'orderNo'">By Order No.</option>
                            <option [ngValue]="'tac'">By Site ID</option>
                            <option [ngValue]="'orderStatus'">By Order Status</option>
                        </select>
                        <div *ngIf="selectedFilter == 'invoiceNumber'" class="search-input-wrapper">
                            <input type="text" class="search-input-compact" placeholder="Invoice Number" [(ngModel)]="invoiceFilter" (ngModelChange)="checkFilter()"
                                (keyup.enter)="changeBackendPagination(page, size, false)" />
                            <button class="search-button-compact" (click)="changeBackendPagination(page, size, false)">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div *ngIf="selectedFilter == 'loadingBol'" class="search-input-wrapper">
                            <input type="text" class="search-input-compact" placeholder="Loading Bol" [(ngModel)]="loadingBolFIlter" (ngModelChange)="checkFilter()"
                                (keyup.enter)="changeBackendPagination(page, size, false)" />
                            <button class="search-button-compact" (click)="changeBackendPagination(page, size, false)">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div *ngIf="selectedFilter == 'orderNo'" class="search-input-wrapper">
                            <input type="text" class="search-input-compact" placeholder="Order Number" [(ngModel)]="orderNoFilter" (ngModelChange)="checkFilter()"
                                (keyup.enter)="changeBackendPagination(page, size, false)" />
                            <button class="search-button-compact" (click)="changeBackendPagination(page, size, false)">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div *ngIf="selectedFilter == 'tac'" class="search-input-wrapper">
                            <input type="text" class="search-input-compact" placeholder="Site ID" [(ngModel)]="tacFilter" (ngModelChange)="checkFilter()"
                                (keyup.enter)="changeBackendPagination(page, size, false)" />
                            <button class="search-button-compact" (click)="changeBackendPagination(page, size, false)">
                                <i class="fa fa-search"></i>
                            </button>
                        </div>
                        <div *ngIf="selectedFilter == 'orderStatus'">
                            <select class="form-select-compact" [(ngModel)]="bolStatusFilter"
                                (change)="changeBackendPagination(0, noOfRecord)">
                                <option [ngValue]="null">Status</option>
                                <option [ngValue]="1">Order Received</option>
                                <option [ngValue]="10">Dispatched</option>
                                <option [ngValue]="12">Enroute to Rack</option>
                                <option [ngValue]="20">At Rack</option>
                                <option [ngValue]="22">Left Rack</option>
                                <option [ngValue]="24">At Location</option>
                                <option [ngValue]="26">Finished</option>
                            </select>
                        </div>
                    </div>
                </div>

                <div class="col-2 menu-section-compact">
                    <div class="filter-header-compact">Division</div>
                    <div class="input-wrapper">
                        <select class="form-select-compact" [(ngModel)]="filterDivision" (change)="changeBackendPagination(page, size, false)">
                            <option [ngValue]="null">Show All</option>
                            <option *ngFor="let division of availableDivisions" [ngValue]="division.divisionSchedPrefix">{{division.divisionSchedPrefix}}</option>
                        </select>
                    </div>
                </div>

                <div class="col-2 menu-section-compact" style="display: flex; align-items: flex-end;">
                    <div style="width: 100%;">
                        <button class="order-button-compact" (click)="openModalForTakeOrder(takeOrderModalForDetails)">Take Order</button>
                        <button class="shift-sort-button-compact"
                            (click)="shiftSort = 'asc'; changeBackendPagination(page, size, false)"
                            *ngIf="shiftSort == 'desc'">
                            Shift DESC <i class="fa fa-caret-down"></i>
                        </button>
                        <button class="shift-sort-button-compact"
                            (click)="shiftSort = 'desc'; changeBackendPagination(page, size, false)"
                            *ngIf="shiftSort == 'asc'">
                            Shift ASC <i class="fa fa-caret-up"></i>
                        </button>
                    </div>
                </div>


                <div class="col-2 billofladingresponse" *ngIf="billOfLaddingResponse 
        && billOfLaddingResponse.billofladings 
        && billOfLaddingResponse.billofladings.length > 0">
                    No. of Loads : [{{billOfLaddingResponse?.billofladings?.length}}]
                </div>
            </div>
            
            <div class="row" style="padding: 0 25px; margin-top: 15px;">
                <div class="col-12">
                    <p style="font-size: 13px; font-style: italic; color: #666; margin: 0;">** NOTE: Please input some text and hit Enter to find the loads !</p>
                </div>
            </div>
<!-- 
            <div class="row billofladingresponsediv" id="billOfLaddingResponseDivEdited" *ngIf="billOfLaddingResponse">
                <div class="col-12 table-responsive">
                    <table class="table table-striped billofladingtable" style="font-size: 12px;
                                    font-size: 12px;
                                    padding: 83px;
                                    margin-left: -4px;
                                    ">
                        <tr>
                            <td width="20px">Trip</td>
                            <td width="20px">BolID</td>
                            <td width="20px">RouteId</td>
                            <td width="20px">OrderNo</td>
                            <td width="20px">Customer</td>
                            <td width="20px">Supplier</td>
                            <td width="20px">TAC</td>
                            <td width="40px">Dealer</td>
                            <td width="20px">Terminal</td>
                            <td width="20px">Split</td>
                            <td width="20px">Product</td>
                            <td width="20px" style="line-height: 25px;">Quantity</td>
                            <td width="20px">BOL Status</td>
                            <td width="20px">Time At Rack</td>
                            <td width="20px">Time Left Rack </td>
                            <td width="20px">Time At Site</td>
                            <td width="20px">Left Time</td>
                        </tr>
                    </table>
                </div>
                <div class="col-12" style="margin-top: -55px;"
                    *ngFor="let selectedItem of billOfLaddingResponse.billofladings | keyvalue: 0">
                    <div style="background-color: #f0f0f0;">
                        <div style="padding-left: 1rem;
                        padding-right: 1rem; margin-top: 38px;">
                            <div class="modal-header row shift-info text-left">
                                <div class="col-7 row">
                                    {{selectedItem?.value?.routeDetailsDTO?.divisionSchedPrefix}} &nbsp; &nbsp;
                                    {{selectedItem?.value?.routeDetailsDTO?.shift}} &nbsp; &nbsp;
                                    {{selectedItem?.value?.routeDetailsDTO?.fName}}
                                    {{selectedItem?.value?.routeDetailsDTO?.lName}} &nbsp; &nbsp;
                                    Truck: {{selectedItem?.value?.routeDetailsDTO?.truckNumber}} &nbsp; &nbsp;
                                    Trailer: {{selectedItem?.value?.routeDetailsDTO?.trailerNumber}} &nbsp; &nbsp;
                                    Shift: {{selectedItem?.value?.routeDetailsDTO?.shift}} &nbsp; &nbsp;
                                    Col: {{selectedItem?.value?.routeDetailsDTO?.col}} &nbsp; &nbsp;
                                    Div: {{selectedItem?.value?.routeDetailsDTO?.divisionSchedPrefix}} &nbsp; &nbsp;
                                    Punch In: {{null != selectedItem?.value?.routeDetailsDTO?.punchIn ?
                                    selectedItem?.value?.routeDetailsDTO?.punchIn : "-"}} &nbsp; &nbsp;
                                    Punch Out: {{null != selectedItem?.value?.routeDetailsDTO?.finishTime ?
                                    selectedItem?.value?.routeDetailsDTO?.finishTime : "-"}} &nbsp; &nbsp;
                                </div>
                            </div>
                        </div>
                        <div class="modal-body row">
                            <hr>
                            <div class="table-responsive" *ngFor="let item of selectedItem?.value?.billofladingDTOs;"
                                style="margin-top: 0px;">
                                <table class="table table-striped" style="font-size: 12px;
                                    font-size: 12px;
                                    padding: 83px;
                                    margin-top: 0px;
                                    margin-left: -4px;
                                    margin-bottom: 0px;">
                                    <tr *ngFor="let detail of item?.billofladingdetails; let detailsCounter = index">
                                        <td width="20px">{{checkCounter(detailsCounter, item?.tripNo)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.billOfLadingId)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.routeID)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.orderNo)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter,
                                            detail?.tblcard?.billtype?.billingCodeName)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter,
                                            detail?.tblcard?.tblloadunder?.loadUnderName)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.dealer?.tac)}}</td>
                                        <td width="40px">{{checkCounter(detailsCounter, item?.dealer?.dealer)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter,
                                            detail?.tblcard?.terminal?.terminalName)}}</td>
                                        <td width="20px"><input *ngIf="!detailsCounter" type="checkbox"
                                                [(ngModel)]="item.split"></td>
                                        <td width="20px">{{detail?.product?.displayCode}}</td>
                                        <td width="20px" style="line-height: 25px;">{{detail?.quantity}}</td>

                                        <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                            {{checkCounter(detailsCounter, (item?.bolstatus > 26 ? ' Finished' :
                                            item?.bolstatus == 1? ' Order Received':
                                            bolstatusMap.get(item.bolstatus+'')))}}</td>
                                        <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.arrivedAtRackTime)}}
                                            </div>
                                        </td>
                                        <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.leftRackTime)}}
                                            </div>
                                        </td>
                                        <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.arrivedAtCustomerTime)}} </div>
                                        </td>
                                        <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.finalizedDeliveryTime)}} </div>
                                        </td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div> -->



            <div class="row billofladingresponsediv" *ngIf="billOfLaddingResponse">
                <div class="col-12 table-responsive">
                    <table class="table table-striped billofladingtable" style="font-size: 12px;
                    font-size: 12px;
                    padding: 83px;
                    margin-left: -4px;
                    ">
                        <div>
                            <tr>
                                <th width="20px">Trip</th>
                                <th width="20px">BolID</th>
                                <th width="20px">RouteId</th>
                                <th width="20px">OrderNo</th>
                                <th width="20px">Customer</th>
                                <th width="20px">Supplier</th>
                                <th width="20px">TAC</th>
                                <th width="40px">Dealer</th>
                                <th width="20px">Terminal</th>
                                <th width="20px">Split</th>
                                <th width="20px">Product</th>
                                <th width="20px" style="line-height: 25px;">Quantity</th>
                                <th width="20px">BOL Status</th>
                                <th width="20px">Time At Rack</th>
                                <th width="20px">Time Left Rack </th>
                                <th width="20px">Time At Site</th>
                                <th width="20px">Left Time</th>
                            </tr>
                        </div>
                        <div *ngFor="let selectedItem of billOfLaddingResponse.billofladings | keyvalue">
                                <div style="padding-left: 1rem;
                            padding-right: 1rem; margin-top: 38px;">
                                <div class="modal-header row shift-info text-left">
                                    <div class="col-7 row">
                                        {{selectedItem?.value?.routeDetailsDTO?.divisionSchedPrefix}} &nbsp; &nbsp;
                                        {{selectedItem?.value?.routeDetailsDTO?.shift}} &nbsp; &nbsp;
                                        {{selectedItem?.value?.routeDetailsDTO?.fName}}
                                        {{selectedItem?.value?.routeDetailsDTO?.lName}} &nbsp; &nbsp;
                                        Truck: {{selectedItem?.value?.routeDetailsDTO?.truckNumber}} &nbsp; &nbsp;
                                        Trailer: {{selectedItem?.value?.routeDetailsDTO?.trailerNumber}} &nbsp; &nbsp;
                                        Shift: {{selectedItem?.value?.routeDetailsDTO?.shift}} &nbsp; &nbsp;
                                        Col: {{selectedItem?.value?.routeDetailsDTO?.col}} &nbsp; &nbsp;
                                        Div: {{selectedItem?.value?.routeDetailsDTO?.divisionSchedPrefix}} &nbsp; &nbsp;
                                        Punch In: {{null != selectedItem?.value?.routeDetailsDTO?.punchIn ?
                                        selectedItem?.value?.routeDetailsDTO?.punchIn : "-"}} &nbsp; &nbsp;
                                        Punch Out: {{null != selectedItem?.value?.routeDetailsDTO?.finishTime ?
                                        selectedItem?.value?.routeDetailsDTO?.finishTime : "-"}} &nbsp; &nbsp;
                                    </div>
                                </div>
                            </div>
                            <div *ngFor="let item of selectedItem?.value?.billofladingDTOs;">
                                <tr *ngFor="let detail of item?.billofladingdetails; let detailsCounter = index">
                                    <td width="20px">{{checkCounter(detailsCounter, item?.tripNo)}}</td>
                                    <td width="20px"><a href="javascript:void(0);" (click)="openModalForDetails(selectionModalForDetails, item)">{{checkCounter(detailsCounter, item?.billOfLadingId)}}</a></td>
                                    <td width="20px">{{checkCounter(detailsCounter, item?.routeID)}}</td>
                                    <td width="20px">{{checkCounter(detailsCounter, item?.orderNo)}}</td>
                                    <td width="20px">{{checkCounter(detailsCounter,
                                        detail?.tblcard?.billtype?.billingCodeName)}}</td>
                                    <td width="20px">{{checkCounter(detailsCounter,
                                        detail?.tblcard?.tblloadunder?.loadUnderName)}}</td>
                                    <td width="20px">{{checkCounter(detailsCounter, item?.dealer?.tac)}}</td>
                                    <td width="40px" style="max-width: 10px;">{{checkCounter(detailsCounter, item?.dealer?.dealer)}}</td>
                                    <td width="20px">{{checkCounter(detailsCounter,
                                        detail?.tblcard?.terminal?.terminalName)}}</td>
                                    <td width="20px"><input *ngIf="!detailsCounter" type="checkbox"
                                            [(ngModel)]="item.split"></td>
                                    <td width="20px">{{detail?.product?.displayCode}}</td>
                                    <td width="20px" style="line-height: 25px;">{{detail?.quantity}}</td>

                                    <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                        {{checkCounter(detailsCounter, (item?.bolstatus > 26 ? ' Finished' :
                                        item?.bolstatus == 1? ' Order Received':
                                        bolstatusMap.get(item.bolstatus+'')))}}</td>
                                    <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                        <div class="time-box" *ngIf="!detailsCounter">
                                            {{formatDateForDisplayHours(item?.arrivedAtRackTime)}}
                                        </div>
                                    </td>
                                    <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                        <div class="time-box" *ngIf="!detailsCounter">
                                            {{formatDateForDisplayHours(item?.leftRackTime)}}
                                        </div>
                                    </td>
                                    <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                        <div class="time-box" *ngIf="!detailsCounter">
                                            {{formatDateForDisplayHours(item?.arrivedAtCustomerTime)}} </div>
                                    </td>
                                    <td width="20px" [ngClass]="findLoadColor(item.bolstatus)">
                                        <div class="time-box" *ngIf="!detailsCounter">
                                            {{formatDateForDisplayHours(item?.finalizedDeliveryTime)}} </div>
                                    </td>
                                </tr>
                            </div>
                        </div>
                    </table>
                </div>
            </div>

            <div class="row billofladingresponsediv hidden-bols" id="billOfLaddingResponseDiv"
                *ngIf="billOfLaddingResponse">
                <div class="col-12 table-responsive">
                    <table class="table table-striped billofladingtable" style="font-size: 12px;
                                    font-size: 12px;
                                    padding: 83px;
                                    margin-left: -4px;
                                    ">
                        <tr>
                            <td width="20px">BOL Status</td>
                            <td width="20px">
                                Time in
                            </td>
                            <td width="20px">Terminal</td>
                            <td width="20px">
                                Time Out
                            </td>
                            <td width="20px">Loadunder:Customer</td>
                            <td width="20px">Time In</td>
                            <td width="20px">TAC</td>
                            <td width="40px">Dealer</td>
                            <td width="20px">Time Out</td>
                            <td width="20px">OrderNo</td>
                            <td width="20px">BolID</td>
                            <td width="20px">Split</td>
                            <td width="20px">Product</td>
                            <td width="20px" style="line-height: 25px;">Quantity</td>
                        </tr>
                    </table>
                </div>
                <div class="col-12" style="margin-top: -55px;"
                    *ngFor="let selectedItem of billOfLaddingResponse.billofladings | keyvalue">
                    <div style="background-color: #f0f0f0;">
                        <div style="padding-left: 1rem;
                        padding-right: 1rem; margin-top: 38px;">
                            <div class="modal-header row shift-info">
                                <div class="col-2">{{selectedItem?.value?.routeDetailsDTO?.divisionSchedPrefix}} </div>
                                <div class="col-2">{{selectedItem?.value?.routeDetailsDTO?.shift}} </div>
                                <div class="col-2">{{selectedItem?.value?.routeDetailsDTO?.fName}}
                                    {{selectedItem?.value?.routeDetailsDTO?.lName}}</div>
                                <div class="col-2">Truck: {{selectedItem?.value?.routeDetailsDTO?.truckNumber}} </div>
                                <div class="col-2">Trailer: {{selectedItem?.value?.routeDetailsDTO?.trailerNumber}}
                                </div>
                            </div>
                        </div>
                        <div class="modal-body row">
                            <hr>
                            <div class="table-responsive" *ngFor="let item of selectedItem?.value?.billofladingDTOs;"
                                style="margin-top: 0px;">
                                <table class="table table-striped" style="font-size: 12px;
                                    font-size: 12px;
                                    padding: 83px;
                                    margin-top: 0px;
                                    margin-left: -4px;
                                    margin-bottom: 0px;">
                                    <tr *ngFor="let detail of item?.billofladingdetails; let detailsCounter = index">
                                        <td width="20px">{{checkCounter(detailsCounter, item?.bolstatus)}}</td>
                                        <td width="20px">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.arrivedAtRackTime)}}
                                            </div>
                                        </td>
                                        <td width="20px">{{checkCounter(detailsCounter,
                                            detail?.tblcard?.terminal?.terminalName)}}</td>
                                        <td width="20px">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.leftRackTime)}}
                                            </div>
                                        </td>
                                        <td width="20px">{{checkCounter(detailsCounter,
                                            detail?.tblcard?.tblloadunder?.loadUnderName)}}</td>
                                        <td width="20px">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.arrivedAtCustomerTime)}} </div>
                                        </td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.dealer?.tac)}}</td>
                                        <td width="40px">{{checkCounter(detailsCounter, item?.dealer?.dealer)}}</td>
                                        <td width="20px">
                                            <div class="time-box" *ngIf="!detailsCounter">
                                                {{formatDateForDisplayHours(item?.finalizedDeliveryTime)}} </div>
                                        </td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.orderNo)}}</td>
                                        <td width="20px">{{checkCounter(detailsCounter, item?.billOfLadingId)}}</td>
                                        <td width="20px"><input *ngIf="!detailsCounter" type="checkbox"
                                                [(ngModel)]="item.split"></td>
                                        <td width="20px">{{detail?.product?.displayCode}}</td>
                                        <td width="20px" style="line-height: 25px;">{{detail?.quantity}}</td>
                                    </tr>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>



            <div class="row" style="padding: 20px; margin-top: 30px;"
                *ngIf="!billOfLaddingResponse || billOfLaddingResponse.billofladings.length == 0">
                <div class="col-12">
                    <i style="font-size: 12px;">** NOTE: Please input some text and hit Enter to find the loads !</i>
                </div>
            </div>

            <button type="button" style="display: none;" #openModal class="btn btn-primary" data-toggle="modal"
                data-target="#errorModal">
                Launch demo modal
            </button>

            <div class="modal fade" id="errorModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel"
                aria-hidden="true">
                <div class="modal-dialog" role="document">
                    <div class="modal-content">
                        <div class="modal-header">
                            <h5 class="modal-title" id="exampleModalLabel">Download</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                        </div>
                        <div class="modal-body">
                            <img *ngIf="!error" src="./assets/images/download.gif" />
                            <img *ngIf="error" src="./assets/images/warning-1.gif" />
                            {{ errorMsg }}
                        </div>
                        <div class="modal-footer">
                            <button type="button" class="btn btn-primary" data-dismiss="modal">
                                Close
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>


    <div class="content-wrapper">
        <button (click)="newDesign = !newDesign" style="margin-left: 50%">New Design</button>
    </div>
</div>

<!-- modal -->
<ng-template #selectionModalForDetails let-c="close" let-d="dismiss">
    <div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
      <h5 class="modal-title" style="font-size: 15px;">Load Details [ {{selectedItem?.billOfLadingId}} ]</h5>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true" style="color: white">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-md-4 loadAddressText">
            <div>{{selectedItem ? selectedItem?.billofladingdetails[0]?.tblcard?.billtype?.displayName : ''}}</div>
            <div>{{selectedItem ? selectedItem?.dealer?.dealer: ''}}</div>
            <div>{{selectedItem ? selectedItem?.dealer?.address:''}}</div>
            <div>{{selectedItem ? selectedItem?.dealer?.city: ''}} {{selectedItem ? selectedItem?.dealer?.state: ''}}
            </div>
            <div>{{selectedItem?selectedItem?.dealer?.address2:''}} </div>
            <div>{{selectedItem?selectedItem?.dealer?.telephone1:''}}</div>
            <div><b>Truck:</b> {{selectedRouteSheet?.truckNumber}}</div>
            <div><b>Trailer:</b> {{selectedRouteSheet?.trailerNumber}}</div>
  
            <div class="bol-info">
              <b>PO:</b> {{selectedItem?.secondOrderNo}}<br>
              <b>Loading BOL:</b> {{selectedItem?.billOfLading}}<br>
            </div>
          </div>
          <div class="col-md-4">
            <div class="row">
              <div class="col-12">
                <b>At Rack :</b> {{selectedItem?.arrivedAtRackTime | date: 'MM/dd/yy HH:mm'}}
              </div>
              <div class="col-12">
                <b>Left Rack : </b> {{selectedItem?.leftRackTime | date: 'MM/dd/yy HH:mm'}}
              </div>
              <div class="col-12">
                <b>At Location </b>: {{selectedItem?.arrivedAtCustomerTime | date: 'MM/dd/yy HH:mm'}}
              </div>
              <div class="col-12">
                <b>Left Location </b>: {{selectedItem?.finalizedDeliveryTime | date: 'MM/dd/yy HH:mm'}}
              </div>
  
              <div class="deliver-when col-12">
                <b>Delivery Window:</b> {{selectedItem?.deliverwhen}}
              </div>
            </div>
          </div>
          <div class="col-md-2 text-center">
            Status
            <div class="col-12" style="font-size: 13px;">
              <!-- {{selectedItem?.bolstatus}} -->
              {{selectedItem?.bolstatus > 26 ? 'Finished' : selectedItem?.bolstatus == 1? 'Order Received':
              bolstatusMap.get(selectedItem.bolstatus+'')}}
            </div>
          </div>
  
          <div class="col-md-2 text-center">
            <button class="button btn-success" *ngFor="let pdf of bolImages" (click)="downloadPdf(pdf)"
              style="     background-color: #567db3;
              border-color: #89bfef;
              margin-left: 29%;
              width: 86%;
              border-radius: 6px;
              height: 29px;">
              <i class="fa fa-download pointer" style="cursor: pointer; color: white !important"></i> {{selectedItem.billOfLadingId}}
            </button>
            <button class="button btn-success" style=" width: 60px; background-color: #567db3; border-color: #89bfef;"
              *ngIf="selectedItem.bolimageSent"
              (click)="downloadFile(selectedItem.billOfLadingId,selectedItem.tenant,false)">
              <i class="fa fa-download pointer" style="cursor: pointer; color: white !important"></i>
            </button>
          </div>
  
          <div class="col-12">
            <app-upload [selectedItem]="selectedItem"></app-upload>
            <button class="button btn-success" style="background-color: #1dd426;
            border-color: #89bfef; margin-left: 75%;
            width: 16%; border-radius: 6px; height: 42px; position: absolute; margin-top: -84px; font-size: 15px;"
              *ngIf="checkEditOption(user)"
              (click)="c('Close click'); openEditModal(editModalForDetails, selectedItem); ">
              <i class="fa fa-pencil pointer" style="cursor: pointer; color: white !important"></i> Edit
            </button>
          </div>
        </div>
  
      </div>
  
      <hr>
  
      <div class="table-responsive">
        <table class="table table-striped" style="font-size: 12px;font-size: 11px;
        padding: 83px;
        margin-top: 8px;
        margin-left: -4px;">
          <thead style="background-color: #9a9a9a" class="text-center">
            <tr>
              <th>
                <b>Terminal</b>
              </th>
              <th>
                <b>Product</b>
              </th>
              <th>
                <b>Supplier</b>
              </th>
              <th>
                <b>Gal Ordered</b>
              </th>
              <th>
                <b>Gal Delivered</b>
              </th>
              <th>
                <b>Gross</b>
              </th>
              <th>
                <b>Net</b>
              </th>
              <th>
                <b>Loading BOL</b>
              </th>
            </tr>
          </thead>
          <tbody [hidden]="!selectedItem" class="text-center">
            <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.billofladingdetails">
              <td [hidden]="!selectedItem">{{item?.tblcard?.terminal?.terminalName}}</td>
              <td [hidden]="!selectedItem">{{item?.product?.productName}}</td>
              <td [hidden]="!selectedItem">{{item?.tblcard?.tblloadunder?.loadUnderName}}</td>
              <td [hidden]="!selectedItem">{{item?.ordered}}</td>
              <td [hidden]="!selectedItem">{{item?.netGallons}}</td>
              <td [hidden]="!selectedItem">{{item.quantity}}</td>
              <td [hidden]="!selectedItem">{{item.netGallons}}</td>
              <td [hidden]="!selectedItem">{{item.billofLadingSub}}</td>
            </tr>
          </tbody>
        </table>
      </div>
      <div class="table-responsive">
        <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
        padding: 83px;
        margin-top: 8px;
        margin-left: -4px;">
          <thead style="background-color: #9a9a9a" class="text-center">
            <tr>
              <td><b>Loading Information</b></td>
              <td><b>Un-Loading Information</b></td>
            </tr>
          </thead>
          <tbody>
            <tr>
              <td>
                <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                            margin-top: 8px;">
                  <thead class="text-center">
                    <tr>
                      <td><b>Start</b></td>
                      <td><b>Finish</b></td>
                      <td><b>Total (Min)</b></td>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>{{selectedItem?.arrivedAtRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                      <td>{{selectedItem?.leftRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                      <td>{{selectedItem?.rackTimeDiff | number : '1.0-0'}}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
              <td>
                <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                            margin-top: 8px;">
                  <thead class="text-center">
                    <tr>
                      <td><b>Start</b></td>
                      <td><b>Finish</b></td>
                      <td><b>Total (Min)</b></td>
                    </tr>
                  </thead>
                  <tbody class="text-center">
                    <tr>
                      <td>{{selectedItem?.arrivedAtCustomerTime | date: 'MM/dd/yy HH:mm'}}</td>
                      <td>{{selectedItem?.finalizedDeliveryTime | date: 'MM/dd/yy HH:mm'}}</td>
                      <td>{{selectedItem?.locationTimeDiff | number : '1.0-0'}}</td>
                    </tr>
                  </tbody>
                </table>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  
      <hr>
      <p>
        <b>Driver Notes: </b>{{selectedItem?.billofladingnotes && selectedItem?.billofladingnotes.length > 0 ?
        selectedItem?.billofladingnotes[0]?.driverNotes: ""}}
      </p>
      <hr>
      <!-- <div class="row text-center">
        <div class="col-12">
        <b>Captured BOL Images</b><br>
          ** Hover on the images to zoom, click on the images to download
        </div>
        <div class="gallery cf">
          <div *ngFor="let image of bolImages">
              <a href="{{image}}" target="_blank">
                <img src="{{image}}" />
              </a>
          </div>
  
        </div>
      </div> -->
  
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary close-modal" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>
  
  <ng-template #editModalForDetails let-c="close" let-d="dismiss">
    <div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
      <h5 class="modal-title" style="font-size: 15px;">Load Details [ {{selectedItem?.billOfLadingId}} ]</h5>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true" style="color: white">&times;</span>
      </button>
    </div>
    <div class="modal-body">
      <div class="container">
        <div class="row">
          <div class="col-md-4 loadAddressText">
            <div>{{selectedItem ? selectedItem?.billofladingdetails[0]?.tblcard?.billtype?.displayName : ''}}</div>
            <div>{{selectedItem ? selectedItem?.dealer?.dealer: ''}}</div>
            <div>{{selectedItem ? selectedItem?.dealer?.address:''}}</div>
            <div>{{selectedItem ? selectedItem?.dealer?.city: ''}} {{selectedItem ? selectedItem?.dealer?.state: ''}}
            </div>
            <div>{{selectedItem?selectedItem?.dealer?.address2:''}} </div>
            <div>{{selectedItem?selectedItem?.dealer?.telephone1:''}}</div>
            <div><b>Truck:</b> {{selectedRouteSheet?.truckNumber}}</div>
            <div><b>Trailer:</b> {{selectedRouteSheet?.trailerNumber}}</div>
  
            <div class="bol-info">
              <b>PO:</b> {{selectedItem?.secondOrderNo}}<br>
              <b>Loading BOL:</b> {{selectedItem?.billOfLading}}<br>
            </div>
          </div>
          <div class="col-md-6">
            <div class="row">
              <div class="col-12 row">
                <div class="col-4"><b>At Rack :</b></div>
                <div class="col-8 12hr-example">
                  <div class="ngx-timepicker-field-example">
                    <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.arrivedAtRackTime, 'arrivedAtRackTimeTemp')" 
                    [format]="12" [(ngModel)]="selectedItem.arrivedAtRackTimeTemp"></ngx-timepicker-field>
                </div>
                </div>
                
              </div>
              <div class="col-12 row">
                <div class="col-4"><b>Left Rack : </b> </div>
                <div class="col-8 12hr-example">
                  <div class="ngx-timepicker-field-example">
                    <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.leftRackTime, 'leftRackTimeTemp')"
                     [format]="12" [(ngModel)]="selectedItem.leftRackTimeTemp"></ngx-timepicker-field>
                </div>
                </div>
              </div>
              <div class="col-12 row">
                <div class="col-4"><b>At Location </b>: </div>
                <div class="col-8 12hr-example">
                  <div class="ngx-timepicker-field-example">
                    <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.arrivedAtCustomerTime, 'arrivedAtCustomerTimeTemp')"
                    [format]="12" [(ngModel)]="selectedItem.arrivedAtCustomerTimeTemp"></ngx-timepicker-field>
                </div>
                </div>
              </div>
              <div class="col-12 row">
                <div class="col-4"><b>Left Location </b>: </div>
                <div class="col-8 12hr-example">
                  <div class="ngx-timepicker-field-example">
                    <ngx-timepicker-field [defaultTime]="convertTime(selectedItem?.finalizedDeliveryTime, 'finalizedDeliveryTimeTemp')"
                    [format]="12" [(ngModel)]="selectedItem.finalizedDeliveryTimeTemp"></ngx-timepicker-field>
                </div>
                </div>
              </div>
  
              <div class="deliver-when col-12">
                <b>Delivery Window:</b> {{selectedItem?.deliverwhen}}
              </div>
            </div>
          </div>
          <div class="col-md-2 text-center">
            Status
            <div class="col-12" style="font-size: 13px;">
              <!-- {{selectedItem?.bolstatus}} -->
              <b>{{selectedItem?.bolstatus > 26 ? 'Finished' : selectedItem?.bolstatus == 1? 'Order Received':
              bolstatusMap.get(selectedItem.bolstatus+'')}}
              </b>
            </div>
          </div>
  
         
        </div>
  
      </div>
  
      <hr>
  
      <div class="col-12 table-responsive">
        <table class="table table-striped" style="font-size: 12px;font-size: 11px;
        padding: 83px;
        margin-top: 8px;
        margin-left: -4px;">
          <thead style="background-color: #9a9a9a" class="text-center">
            <tr>
              <th>
                <b>Terminal</b>
              </th>
              <th>
                <b>Product</b>
              </th>
              <th>
                <b>Supplier</b>
              </th>
              <th>
                <b>Gal Ordered</b>
              </th>
              <th>
                <b>Gal Delivered</b>
              </th>
              <th>
                <b>Gross</b>
              </th>
              <th>
                <b>Net</b>
              </th>
              <th>
                <b>Loading BOL</b>
              </th>
            </tr>
          </thead>
          <tbody [hidden]="!selectedItem" class="text-center">
            <tr [hidden]="!selectedItem" *ngFor="let item of selectedItem?.billofladingdetails">
              <td class="td-edit" [hidden]="!selectedItem">{{item?.tblcard?.terminal?.terminalName}}</td>
              <td class="td-edit" [hidden]="!selectedItem">{{item?.product?.productName}}</td>
              <td class="td-edit" [hidden]="!selectedItem">{{item?.tblcard?.tblloadunder?.loadUnderName}}</td>
              <td class="td-edit" [hidden]="!selectedItem">{{item?.ordered}}</td>
              <td class="td-edit" [hidden]="!selectedItem">{{item?.netGallons}}</td>
              <td class="td-edit" [hidden]="!selectedItem"><input class="edit-boxes" type="text" [(ngModel)]="item.quantity"></td>
              <td class="td-edit" [hidden]="!selectedItem"><input class="edit-boxes" type="text" [(ngModel)]="item.netGallons"></td>
              <td class="td-edit" [hidden]="!selectedItem"><input class="edit-boxes" type="text" [(ngModel)]="item.billofLadingSub"></td>
            </tr>
          </tbody>
        </table>
      </div>
      <br>
      <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
      padding: 83px;
      margin-top: 8px;
      margin-left: -4px;">
        <thead style="background-color: #9a9a9a" class="text-center">
          <tr>
            <td><b>Loading Information</b></td>
            <td><b>Un-Loading Information</b></td>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                          margin-top: 8px;">
                <thead class="text-center">
                  <tr>
                    <td><b>Start</b></td>
                    <td><b>Finish</b></td>
                    <td><b>Total (Min)</b></td>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr>
                    <td>{{selectedItem?.arrivedAtRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                    <td>{{selectedItem?.leftRackTime | date: 'MM/dd/yy HH:mm'}}</td>
                    <td>{{selectedItem?.rackTimeDiff | number : '1.0-0'}}</td>
                  </tr>
                </tbody>
              </table>
            </td>
            <td>
              <table class="table table-striped table-bordered" style="font-size: 12px;font-size: 12px;
                          margin-top: 8px;">
                <thead class="text-center">
                  <tr>
                    <td><b>Start</b></td>
                    <td><b>Finish</b></td>
                    <td><b>Total (Min)</b></td>
                  </tr>
                </thead>
                <tbody class="text-center">
                  <tr>
                    <td>{{selectedItem?.arrivedAtCustomerTime | date: 'MM/dd/yy HH:mm'}}</td>
                    <td>{{selectedItem?.finalizedDeliveryTime | date: 'MM/dd/yy HH:mm'}}</td>
                    <td>{{selectedItem?.locationTimeDiff | number : '1.0-0'}}</td>
                  </tr>
                </tbody>
              </table>
            </td>
          </tr>
        </tbody>
      </table>
  
      <hr>
      <p>
        <b>Driver Notes: </b>{{selectedItem?.billofladingnotes && selectedItem?.billofladingnotes.length > 0 ?
        selectedItem?.billofladingnotes[0]?.driverNotes: ""}}
      </p>
      <hr>
      
    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-primary close-modal" (click)="saveLoad(); c('Close click')">Save</button>
      <button type="button" class="btn btn-secondary close-modal" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>

<!-- modal for take order-->
<ng-template #takeOrderModalForDetails let-c="close" let-d="dismiss" class="minimal-modal-z-index">
    <div class="modal-header" style="background-color: #4c6e9e; color: #ffffff;">
      <h5 class="modal-title" style="font-size: 15px;">Take Order</h5>
      <button type="button" class="close" aria-label="Close" (click)="d('Cross click')">
        <span aria-hidden="true" style="color: white">&times;</span>
      </button>
    </div>
    <div class="modal-body">
        <div *ngIf="!takeOrderActive">
            <div style=" margin-top: 20px; margin-bottom: 20px" *ngIf="dealers.length > 0">
              <h6><b>Select Dealer</b></h6>
              <ng-select [(ngModel)]="selectedDealer" [virtualScroll]="true" class="custom"
                (ngModelChange)="changeDealerFilter()" placeholder="Start typing to search dealer..."
                (click)="checkTenantFiltersAvailability()">
                <ng-option *ngFor="let dealer of dealers; let dealerIndex = index" [value]="dealer">
                  {{dealer?.dealer}} | {{dealer?.address}}</ng-option>
              </ng-select>
            </div>
            <!-- <div class="col-12 text-center" *ngIf="true">
              <button class="take-order-button" (click)="takeOrderActive = true; takeOrder()">Take Order</button>
            </div> -->
            <div  *ngIf="true">
              <h6>Take an Order</h6>
              <div class="row">
                <div class="col-4">Location Id : {{selectedDealer?.locationID}}</div>
                <div class="col-4">Dealer : {{selectedDealer?.billtype?.billingCodeName}}</div>
                <div class="col-4" style="margin-top: -20px">
                  <button class="take-order" (click)="captureOrder();">Place Order</button>
                </div>
        
                <div class="col-4">TAC : {{selectedDealer?.tac}}</div>
                <div class="col-4">TAC : {{selectedDealer?.address}}</div>
                <div class="col-4">CO Billtype : {{selectedDealer?.billtype?.billingCodeName}}</div>
        
                <div class="col-4">City : {{selectedDealer?.city}}</div>
                <div class="col-4">State : {{selectedDealer?.state}}</div>
                <div class="col-4">Zip : {{selectedDealer?.zip}}</div>
              </div>
        
              <div class="row" style="margin-top: 20px">
                <div class="col-3">
                  Cust Order No:
                  <div><input type="text" class="take-order-input" [(ngModel)]="takeOrderModel.salesOrderNumber"></div>
                </div>
                <div class="col-3">
                  Po No:
                  <div><input type="text" class="take-order-input" [(ngModel)]="takeOrderModel.customerPO"></div>
                </div>
                
              </div>
              <div class="row">
                <div class="col-4">
                  Delivery Window start:
                  <div class="form-group">
                    <div class="input-group">
                      <label style="margin-left: -2%;">
                        <input [owlDateTimeTrigger]="dt12" [owlDateTime]="dt12" placeholder="yyyy-MM-dd HH:mm:ss"
                          [(ngModel)]="takeOrderModel.deliveryTimeStart" (ngModelChange)="selectDeliveryDate()" [selectMode]="'rangeFrom'" class="dateTimeSelector" />
                        <owl-date-time #dt12></owl-date-time>
                        <span class="trigger" [owlDateTimeTrigger]="dt12">
                          <i class="fa fa-calendar calendar-selector"></i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  Delivery Window end:
                  <div class="form-group">
                    <div class="input-group">
                      <label style="margin-left: -2%;">
                        <input [owlDateTimeTrigger]="dt13" [owlDateTime]="dt13" placeholder="yyyy-MM-dd HH:mm:ss"
                          [(ngModel)]="takeOrderModel.deliveryTimeStart" [selectMode]="'rangeTo'" class="dateTimeSelector" />
                        <owl-date-time #dt13></owl-date-time>
                        <span class="trigger" [owlDateTimeTrigger]="dt13">
                          <i class="fa fa-calendar calendar-selector"></i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
                <div class="col-4">
                  <div>Schedule Date</div>
                  <div class="form-group">
                    <div class="input-group">
                      <label style="margin-left: -2%;">
                        <input [owlDateTimeTrigger]="dt3" [owlDateTime]="dt3" class="take-order-input"
                          [(ngModel)]="takeOrderModel.deliveryDate" [ngModelOptions]="{standalone: true}"
                          class="dateTimeSelector" placeholder="yyyy-MM-dd 00:00:00" disabled>
                        <owl-date-time [pickerType]="'calendar'" #dt3></owl-date-time>
                        <span class="trigger" [owlDateTimeTrigger]="dt3">
                          <i class="fa fa-calendar calendar-selector"></i>
                        </span>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
              <div class="row">
                <div class="col-12">
                  Notes for Driver:
                  <div>
                    <textarea class="take-order-textarea" rows="3" [(ngModel)]="takeOrderModel.loadingNotes"></textarea>
                  </div>
                </div>
                <!-- <div class="col-6">
                  Notes for Dispatcher:
                  <div>
                    <textarea class="take-order-textarea" rows="3" [(ngModel)]="takeOrderModel.dispatchNotes"></textarea>
                  </div>
                </div> -->
              </div>
        
              <div class="row" style="margin-bottom: 20px;">
                <div class="col-1 ">
                  <button class="add-product-button" (click)="addProduct()">
                    <i class="fa fa-plus"></i>
                  </button>
                </div>
                <div class="col-1 "></div>
                <div class="col-2 "><b>Quantity </b></div>
                <div class="col-2 "><b>Product </b></div>
                <!-- <div class="col-2 "><b>Tank Name </b></div> -->
                <div class="col-2 "><b>Terminal </b></div>
                <div class="col-2 "><b>Supplier/Load Under </b></div>
              </div>
              <div class="row" *ngFor="let product of products">
                <div class="col-1 text-center">
                  <button class="remove-product-button" (click)="removeProduct(product)">
                    <i class="fa fa-trash"></i>
                  </button>
                </div>
                <div class="col-1">
                  <div class="color-box" [ngClass]="product?.class"></div>
                </div>
                <div class="col-2 "><input type="text" class="take-order-input" [(ngModel)]="product.quantity"></div>
                <div class="col-2 ">{{product?.productName}}
                  <ng-select [(ngModel)]="newProductAdded" [virtualScroll]="true" class="custom" *ngIf="!product?.productName"
                    (ngModelChange)="addProduct(product, newProductAdded)" placeholder="Start typing to search carrier"
                    (click)="checkTenantFiltersAvailability()" style="margin-top: -8px">
                    <ng-option *ngFor="let newProduct of productList; let productIndex = index" [value]="newProduct">
                      {{newProduct?.productName}}</ng-option>
                  </ng-select>
                </div>
                <!-- <div class="col-2 ">{{product?.tankName? product?.tankName : "Not Available"}}</div> -->
                <div class="col-2 "><input type="text" disabled class="take-order-input" [value]="product.terminalId"></div>
                <div class="col-2 "><input type="text" disabled class="take-order-input" [value]="product.terminalId"></div>
              </div>
            </div>
          </div>

         

    </div>
    <div class="modal-footer">
      <button type="button" class="btn btn-secondary close-modal" (click)="c('Close click')">Close</button>
    </div>
  </ng-template>